import { recordPath, recordRoute } from '@/shared/registry'

/** Where the badge provider pages live: each is a Credly connection. */
export const badgeProvidersPath = '/credentials/badge-providers'
export const createBadgeProviderPath = `${badgeProvidersPath}/new`
export const badgeProviderRoute = recordRoute('credentials', 'badge-providers')
export const editBadgeProviderRoute = `${badgeProviderRoute}/edit`

/** A badge provider's details page. */
export function badgeProviderPath(id: string): string {
  return recordPath('credentials', 'badge-providers', id)
}

/** The base of Badge Provider Details' slots (`detailsSlots`). */
export const badgeProviderDetailsSlot = 'credentials.badge-provider-details'

/** The permissions the badge provider screens show or hide their actions by. */
export const readCredlyConnectionsPermission = 'credentials.credly-connections.read'
export const writeCredlyConnectionsPermission = 'credentials.credly-connections.write'
export const deleteCredlyConnectionsPermission = 'credentials.credly-connections.delete'

/** The API's Credly connection endpoints. */
export const credlyConnectionsApi = '/credentials/v1/credly-connections'

export function credlyConnectionApi(id: string): string {
  return `${credlyConnectionsApi}/${encodeURIComponent(id)}`
}
